import { ISelectBox } from 'customTypes';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  // width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 4.5rem;
    padding: 0.75rem 0.5rem;
    border-radius: 3px;
    font-size: 0.85rem !important;
    height: 2.5rem;

    &.readOnly {
      cursor: default;
    }

    &.blue {
      color: var(--badge-primary-text);
      background-color: var(--tonal-blue);

      &.active {
        color: #fff;
        background-color: var(--primary);
        box-shadow: 2px 2px 6px 0px rgba(66, 148, 255, 0.5);
      }
    }

    &.yellow {
      color: var(--filled-yellow);
      background-color: var(--tonal-amber);

      &.active {
        color: #fff;
        background-color: var(--filled-yellow);
        box-shadow: 2px 2px 6px 0px rgba(234, 179, 8, 0.5);
      }
    }

    &.green {
      color: var(--filled-green-deep);
      background-color: var(--tonal-green);

      &.active {
        color: #fff;
        background-color: var(--filled-green-deep);
        box-shadow: 2px 2px 6px 0px rgba(5, 150, 105, 0.5);
      }
    }

    &.red {
      color: var(--filled-red);
      background-color: var(--tonal-red);

      &.active {
        color: #fff;
        background-color: var(--filled-red);
        box-shadow: 2px 2px 6px 0px rgba(244, 63, 94, 0.5);
      }
    }

    &.violet {
      color: var(--filled-violet);
      background-color: var(--tonal-violet);

      &.active {
        color: #fff;
        background-color: var(--filled-violet);
        box-shadow: 2px 2px 6px 0px rgba(139, 92, 246, 0.5);
      }
    }

    &:disabled {
      cursor: default;
    }

    @media screen and (max-width: 767px) {
      min-width: 3rem;
    }
  }
`;

interface Props {
  dataList: ISelectBox[];
  onClickFn?: any;
  currentData?: string; // 현재 값 | 클릭된 값
  viewMode?: 'Y' | 'N'; // 읽기 모드
  disabled?: boolean;
}

const TabColorButtons = ({ dataList, onClickFn, currentData, viewMode = 'N', disabled = false }: Props) => {
  const { t } = useTranslation();

  // 읽기 모드
  if (viewMode === 'Y') {
    return (
      <Root>
        {dataList.map((item: ISelectBox) => (
          <button type='button' key={item.v} className={`${item.color} active readOnly`} disabled>
            {t(item.cdName)}
          </button>
        ))}
      </Root>
    );
  }

  return (
    <Root>
      {dataList.map((item: ISelectBox) => (
        <button type='button' key={item.v} className={`${item.color} ${item.v === currentData ? 'active' : ''}`} onClick={() => onClickFn(item)} disabled={disabled}>
          {t(item.cdName)}
        </button>
      ))}
    </Root>
  );
};

export default TabColorButtons;
